export interface LoginPayload {
  username_or_email: string;
  password: string;
  deviceToken?: string | null;
  panel_type: number;
  device_type: number;
}

export interface User {
  id: number;
  username: string;
  email: string;
  first_name: string;
  last_name: string;
  maf_sso_id: string;
  groups: string[];
  assigned_malls: any[];
  assigned_csos: any[];
  assigned_services?: {
    service_id: number; // Assuming service_id exists based on pattern
    service_name: string;
    [key: string]: any;
  }[];
  assessments_count?: number;
}

export interface LoginResponse {
  user: User;
  access: string;
  refresh: string;
  me: User;
}

export enum Roles {
  SUPER_ADMIN = "SUPER_ADMIN",
  QA = "QA",
  CS = "CS",
  MALL_MANAGER = "MALL_MANAGER",
  SUPERVISOR = "SUPERVISOR",
  EVALUATOR = "EVALUATOR",
  CSO = "CSO",
}
